import {
  Select as MantineSelect,
  type SelectProps as MantineSelectProps,
} from "@mantine/core";
import type { CoreComponentProps } from "../../types";
import { useShouldRender } from "../../../hooks/useShouldRender";

export type SelectProps = CoreComponentProps<MantineSelectProps, 'input'>;

export function Select({ testId, view = "all", ...rest }: SelectProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantineSelect data-testid={testId} {...rest} />;
}
